module.exports = __webpack_public_path__ + "14four/static/media/spinner.282fc418.svg";